module.exports = __webpack_public_path__ + "img/flag-pe.c276ee8a.png";